import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_NEW + '/crateValidationRules'

const rules = axios.create({
  baseURL
})

interceptorsSetup(rules)

export default class CrateValidationRule {
  static async getAll () {
    const result = await rules.get('/')
    return result.data
  }

  static async create (payload) {
    const result = await rules.post('/', payload)
    return result.data
  }

  static async update (id, payload) {
    const result = await rules.put(`/${id}`, payload)
    return result.data
  }
}
